var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRunContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3738,
    height: 146,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#a)",
    d: "M361.53 1.39c24 .5 71.9 15 71.5 69-.5 67.5-67.5 70-71.5 70s-71.5-3-71.5-70c0-53.6 47.667-68.333 71.5-69Zm0 36.5c-21 0-31.5 17-31.5 32.5s7.5 34.5 31.5 34.5 31.5-19 31.5-34.5-10.5-32.5-31.5-32.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#b)",
    d: "M1582.53 1.39c24 .5 71.9 15 71.5 69-.5 67.5-67.5 70-71.5 70s-71.5-3-71.5-70c0-53.6 47.67-68.333 71.5-69Zm0 36.5c-21 0-31.5 17-31.5 32.5s7.5 34.5 31.5 34.5 31.5-19 31.5-34.5-10.5-32.5-31.5-32.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#c)",
    d: "M2778.53 1.39c24 .5 71.9 15 71.5 69-.5 67.5-67.5 70-71.5 70s-71.5-3-71.5-70c0-53.6 47.67-68.333 71.5-69Zm0 36.5c-21 0-31.5 17-31.5 32.5s7.5 34.5 31.5 34.5 31.5-19 31.5-34.5-10.5-32.5-31.5-32.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#d)",
    d: "M267.03 18.39c-6.833-6.833-28.1-19.8-58.5-17-38 3.5-63.528 33.434-62.5 73 1 38.5 26.5 65.5 72 65.5 28.5 0 44.5-10.5 52-15.5l-17-32.5c-5.833 3.833-19 11-33.5 10.5s-32-7-33.5-28 10-35.5 33.5-35.5c11.5 0 22 3.5 28.5 11l19-31.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#e)",
    d: "M1488.03 18.39c-6.83-6.833-28.1-19.8-58.5-17-38 3.5-63.53 33.434-62.5 73 1 38.5 26.5 65.5 72 65.5 28.5 0 44.5-10.5 52-15.5l-17-32.5c-5.83 3.833-19 11-33.5 10.5s-32-7-33.5-28 10-35.5 33.5-35.5c11.5 0 22 3.5 28.5 11l19-31.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#f)",
    d: "M2684.03 18.39c-6.83-6.833-28.1-19.8-58.5-17-38 3.5-63.53 33.434-62.5 73 1 38.5 26.5 65.5 72 65.5 28.5 0 44.5-10.5 52-15.5l-17-32.5c-5.83 3.833-19 11-33.5 10.5s-32-7-33.5-28 10-35.5 33.5-35.5c11.5 0 22 3.5 28.5 11l19-31.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#g)",
    d: "M1020.53 18.39c-6.83-6.833-28.1-19.8-58.5-17-38 3.5-63.528 33.434-62.5 73 1 38.5 26.5 65.5 72 65.5 28.5 0 44.5-10.5 52-15.5l-17-32.5c-5.83 3.833-19 11-33.5 10.5s-32-7-33.5-28 10-35.5 33.5-35.5c11.5 0 22 3.5 28.5 11l19-31.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#h)",
    d: "M2241.53 18.39c-6.83-6.833-28.1-19.8-58.5-17-38 3.5-63.53 33.434-62.5 73 1 38.5 26.5 65.5 72 65.5 28.5 0 44.5-10.5 52-15.5l-17-32.5c-5.83 3.833-19 11-33.5 10.5s-32-7-33.5-28 10-35.5 33.5-35.5c11.5 0 22 3.5 28.5 11l19-31.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#i)",
    d: "M3437.53 18.39c-6.83-6.833-28.1-19.8-58.5-17-38 3.5-63.53 33.434-62.5 73 1 38.5 26.5 65.5 72 65.5 28.5 0 44.5-10.5 52-15.5l-17-32.5c-5.83 3.833-19 11-33.5 10.5s-32-7-33.5-28 10-35.5 33.5-35.5c11.5 0 22 3.5 28.5 11l19-31.5Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#j)",
    d: "M469.53 136.39V3.89h38.5l47 71.5V3.89h37v132.5h-39l-47-73v73h-36.5Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#k)",
    d: "M1690.53 136.39V3.89h38.5l47 71.5V3.89h37v132.5h-39l-47-73v73h-36.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#l)",
    d: "M2886.53 136.39V3.89h38.5l47 71.5V3.89h37v132.5h-39l-47-73v73h-36.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#m)",
    d: "M624.03 38.39V3.89h106.5v34.5h-34v98h-38.5v-98h-34Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#n)",
    d: "M1845.03 38.39V3.89h106.5v34.5h-34v98h-38.5v-98h-34Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#o)",
    d: "M3041.03 38.39V3.89h106.5v34.5h-34v98h-38.5v-98h-34Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#p)",
    d: "m739.53 136.39 48.5-132.5h45.5l48.5 132.5h-43.5l-7.5-23.5h-41.5l-7.5 23.5h-42.5Zm71-92.5-13 37h25.5l-12.5-37Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#q)",
    d: "m1960.53 136.39 48.5-132.5h45.5l48.5 132.5h-43.5l-7.5-23.5h-41.5l-7.5 23.5h-42.5Zm71-92.5-13 37h25.5l-12.5-37Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#r)",
    d: "m3156.53 136.39 48.5-132.5h45.5l48.5 132.5h-43.5l-7.5-23.5h-41.5l-7.5 23.5h-42.5Zm71-92.5-13 37h25.5l-12.5-37Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#s)",
    d: "M1044.03 38.89V3.39h106.5v35.5h-34v97.5h-38.5v-97.5h-34Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#t)",
    d: "M2265.03 38.89V3.39h106.5v35.5h-34v97.5h-38.5v-97.5h-34Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#u)",
    d: "M3461.03 38.89V3.39h106.5v35.5h-34v97.5h-38.5v-97.5h-34Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 22.255,
    x2: 200.397,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1243.26,
    x2: 1421.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 2439.26,
    x2: 2617.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 22.255,
    x2: 200.397,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 1243.25,
    x2: 1421.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 2439.25,
    x2: 2617.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 22.255,
    x2: 200.397,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 1243.26,
    x2: 1421.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 2439.26,
    x2: 2617.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 22.255,
    x2: 200.397,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 1243.25,
    x2: 1421.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 2439.25,
    x2: 2617.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 22.255,
    x2: 200.397,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 1243.26,
    x2: 1421.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 2439.26,
    x2: 2617.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 22.255,
    x2: 200.397,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 1243.26,
    x2: 1421.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 2439.26,
    x2: 2617.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 22.255,
    x2: 200.397,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 1243.26,
    x2: 1421.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 2439.26,
    x2: 2617.4,
    y1: 107.451,
    y2: -332.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunContact);
export default __webpack_public_path__ + "static/media/run_contact.5723c17b448936def8c31cca806cc1d1.svg";
export { ForwardRef as ReactComponent };